import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const LoadingContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "16px 0px",
});

export const EmptyContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "24px 12px",
  "& span": {
    fontFamily: "Manrope",
    fontSize: "16px",
    fontWeight: 600,
    color: colors.gray500,
    lineHeight: "24px",
    letterSpacing: "0.15px",
  },
});

export const ContainerItem = styled("div")<{ isDraggingOver?: boolean }>(({ isDraggingOver }) => ({
  borderRadius: "4px",
  background: isDraggingOver ? colors.blue100 : colors.white,
  marginBottom: "8px",
  padding: "8px 16px",
  width: "368px",
  minHeight: "40px",
}));

export const ResourceItem = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "isDragging" && propName !== "canDrag";
  },
})<{ isDragging?: boolean; canDrag?: boolean }>(({ isDragging, canDrag }) => ({
  opacity: isDragging ? 0.5 : 1,
  cursor: canDrag ? "grab" : "default",
}));

export const ResourceItemChild = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "isDraggingOver";
  },
})<{ isDraggingOver?: boolean }>(({ isDraggingOver }) => ({
  backgroundColor: isDraggingOver ? "rgba(0, 0, 0, 0.05)" : "transparent",
  transition: "background-color 0.2s",
}));
